import { RootState } from 'utils/interfaces'

export const selectLoadingProgress = (state: RootState) => state.missionControl.loadingProgress
